import { Link } from "react-router-dom";
import { Inbox, MailPlus, ScrollText, Send } from "lucide-react";
import React from "react";

const Dashboard = () => {
  return (
    <main className="container">
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-1">
          Willkommen beim Muster-Onlinedienst
        </h1>
        <p className="text-base-content/70">
          Dies ist ein Muster-Onlinedienst für Demo- und Präsentationszwecke.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <div className="card bg-base-100 shadow-sm">
          <div className="card-body">
            <h2 className="card-title">
              <Send className="w-6" />
              Generischer Sender
            </h2>
            <p>Nachrichten frei konfigurieren und versenden.</p>
            <div className="card-actions justify-end mt-3">
              <Link to="/generic-sender" className="btn btn-primary">
                Nachricht versenden
              </Link>
            </div>
          </div>
        </div>

        <div className="card bg-base-100 shadow-sm">
          <div className="card-body">
            <h2 className="card-title">
              <ScrollText className="w-6" />
              Event-Log
            </h2>
            <p>Auflisten aller Security Event Tokens des Event-Logs.</p>
            <div className="card-actions justify-end mt-3">
              <Link to="/event-log" className="btn btn-primary">
                Protokoll Anzeigen
              </Link>
            </div>
          </div>
        </div>

        <div className="card bg-base-100 shadow-sm">
          <div className="card-body">
            <h2 className="card-title">
              <Inbox className="w-6" />
              Zustellpunkte finden
            </h2>
            <p>FIT-Connect Zustellpunkte via Routingdienst suchen.</p>
            <div className="card-actions justify-end mt-3">
              <Link to="/search-destinations" className="btn btn-primary">
                Jetzt suchen
              </Link>
            </div>
          </div>
        </div>

        <div className="card bg-base-100 shadow-sm">
          <div className="card-body">
            <h2 className="card-title">
              <MailPlus className="w-6" />
              Replies
            </h2>
            <p>Antworten auf eine Nachricht einsehen.</p>
            <div className="card-actions justify-end mt-3">
              <Link to="/replies" className="btn btn-primary">
                Antworten einsehen
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Dashboard;
